import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const secondaryAppConfig = {
  apiKey: process.env.REACT_APP_AUTH_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_AUTH_PROJECT_ID,
  storageBucket: process.env.REACT_APP_AUTH_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_AUTH_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_AUTH_APP_ID,
  measurementId: process.env.REACT_APP_AUTH_MEASUREMENT_ID
};

// Initialize Firebase
const secondaryApp = initializeApp(secondaryAppConfig, "secondary");

export const auth = getAuth(secondaryApp);